import { useRef } from 'react';
import { useDisclosure } from '@/ui';

export const useAddFreqWithMessageWarning = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const callback = useRef<null | (() => void)>(null);

  return {
    isOpen,
    open: (onConfirm: () => void) => {
      callback.current = onConfirm;
      onOpen();
    },
    confirm: () => {
      callback.current?.();
      callback.current = null;
      onClose();
    },
    cancel: () => {
      callback.current = null;
      onClose();
    },
  };
};
